export enum CarbonEnvName {
  ALPHA = "alpha",
  PROD = "prod",
  DEV = "dev",
  PREVIEW = "preview",
}
